import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend/cjs';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';
import { Language } from 'src/interface';
import { getLocalStorageItem, setLocalStorageItem } from 'src/helper';
import { LANGUAGE } from 'src/constants';
import { resources } from './resource';

const browserLang = (
  navigator.language
    ? navigator.language.slice(0, 2).toLowerCase()
    : Language.EN
) as Language;
const defaultLang = Object.values(Language).includes(browserLang)
  ? browserLang
  : Language.EN;
const locale = getLocalStorageItem(LANGUAGE, defaultLang);
setLocalStorageItem(LANGUAGE, locale);

i18n
  .use(HttpBackend)
  .use(ICU)
  .use(initReactI18next)
  .init({
    lng: locale,
    fallbackLng: Language.EN,
    keySeparator: false,
    nsSeparator: false,
    resources: resources,
    debug: true,
    react: {
      useSuspense: false,
    },
  });

export { default } from 'i18next';
